import config from './index'

const getOrigin = () => {
    const loc = window.location
    if (loc.origin) return loc.origin

    return `${loc.protocol}//${loc.hostname}${loc.port ? `:${loc.port}` : ''}`
}

const getConfiguration = () => {
    const origin = getOrigin()

    return {
        authority: config.IDENTITY_AUTHORITY,
        client_id: config.IDENTITY_CLIENT_ID,
        scope: 'openid profile oztix_client_api oztix_client_identity',
        redirect_uri: `${origin}/signin-redirect-callback`,
        response_type: 'token id_token',
        silent_redirect_uri: `${origin}/silent-renew`,
        post_logout_redirect_uri: `${origin}/`,
        automaticSilentRenew: true,
        loadUserInfo: true,
        filterProtocolClaims: false,
        triggerAuthFlow: true,
        clockSkew: 900,
    }
}

export default getConfiguration()
